// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__fVjvz","choiceBoxes":"toolbarselects_choiceBoxes__2LIk4","simpleField":"toolbarselects_simpleField__2WXwc"};